import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

import { catchError, map, of } from 'rxjs';
import { ErrorCode } from '@app-shared/enums';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthenticationService);

  const currentUrl = state.url;

  if (!authService.isAuthenticated()) {
    router.navigate(['/login'], {
      queryParams: {
        returnUrl: state.url,
      },
    });
    return false;
  }

  if (authService.isAuthenticated() && !authService.getCurrentUser()) {
    return authService.loadUser().pipe(
      map(() => {
        if (currentUrl.includes('reset-password')) {
          return router.createUrlTree(['/']);
        }
        return true;
      }),
      catchError((error) => {
        const { error_code } = error.error;
        if (error_code === ErrorCode.NOT_RESET_PASSWORD_YET) {
          if (currentUrl.includes('reset-password')) {
            return of(true);
          } else {
            return of(router.createUrlTree(['/reset-password']));
          }
        }
        if (error_code === ErrorCode.ALREADY_RESET_PASSWORD) {
          if (!currentUrl.includes('reset-password')) {
            return of(true);
          } else {
            return of(router.createUrlTree(['/']));
          }
        }
        authService.clearUser();
        return of(router.createUrlTree(['/login']));
      })
    );
  }

  return true;
};
